import DeliveryWindowModal from 'components/RwdCheckout/Sections/SddSections/SddSection/DeliveryWindow/DeliveryWindowModal/DeliveryWindowModal';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import SddSectionEN from 'components/RwdCheckout/Sections/SddSections/SddSection/locales/SddSection_en_US.js';
import SddSectionFR from 'components/RwdCheckout/Sections/SddSections/SddSection/locales/SddSection_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(SddSectionEN, SddSectionFR);

const textResources = createStructuredSelector({
    cancelLinkText: getTextFromResource(getText, 'cancelLinkText'),
    confirm: getTextFromResource(getText, 'confirm')
});

const connectedDeliveryWindowModal = connect(
    createSelector(textResources, texts => {
        return texts;
    })
);

const withDeliveryWindowModalProps = wrapHOC(connectedDeliveryWindowModal);

export default withDeliveryWindowModalProps(DeliveryWindowModal);
